export default {
  nav: {
    home: 'Accueil',
    spreadsheet: 'Spreadsheet',
    guides: 'Guides',
    shopping_guide: 'Guide d\'Achat',
    shipping: 'Expédition',
    qc: 'QC',
    reviews: 'Avis',
    categories: 'Catégories',
    language: 'Langue',
  },
  hero: {
    title: 'AllChinaBuy Spreadsheet – Produits, Vendeurs, QC & Guides d\'Achat',
    subtitle: 'Votre Hub Ressources AllChinaBuy Spreadsheet & Achat',
    description: 'Découvrez des ressources AllChinaBuy spreadsheet utiles, listes de produits, informations vendeurs, guides QC, conseils d\'expédition et astuces d\'achat pratiques — organisés dans un hub facile à utiliser.',
    cta_primary: 'Explorer AllChinaBuy Spreadsheet',
    cta_secondary: 'Parcourir les Guides d\'Achat',
    trust: 'Ressources indépendantes • Contenu mis à jour • Informations d\'achat pratiques',
  },
  categories: {
    title: 'Catégories Populaires AllChinaBuy Spreadsheet',
    subtitle: 'Parcourez les catégories de produits et trouvez ce dont vous avez besoin plus rapidement',
    shoes: 'Chaussures',
    hoodies: 'Hoodies/Pulls',
    tshirts: 'T-Shirts',
    jackets: 'Vestes',
    pants: 'Pantalons/Shorts',
    headwear: 'Couvre-Chefs',
    sets: 'Ensembles',
    underwear: 'Sous-Vêtements',
    jersey: 'Maillots',
    accessories: 'Accessoires',
    bags: 'Sacs',
    belts: 'Ceintures',
    perfumes: 'Parfums',
    other: 'Autres Articles',
  },
  cta: {
    title: 'Prêt à Commencer vos Achats ?',
    description: 'Visitez notre site principal pour l\'expérience AllChinaBuy spreadsheet complète et commencez à trouver des produits dès aujourd\'hui.',
    button_main: 'AllChinaBuy Spreadsheet',
    button_buy: 'Achetez Maintenant',
  },
  articles: {
    title: 'Derniers Guides AllChinaBuy Spreadsheet',
    subtitle: 'Apprenez à acheter plus intelligemment avec nos ressources complètes',
    read_more: 'Lire la Suite',
    article_1_title: 'Guide Complet AllChinaBuy Spreadsheet 2026',
    article_1_desc: 'Tout ce que vous devez savoir sur l\'utilisation du spreadsheet AllChinaBuy pour trouver des produits, comparer les vendeurs et prendre des décisions d\'achat éclairées.',
    article_2_title: 'Comment Lire les Photos QC AllChinaBuy',
    article_2_desc: 'Un guide étape par étape pour comprendre les photos de contrôle qualité et vérifier les détails des produits avant d\'acheter.',
    article_3_title: 'Méthodes d\'Expédition AllChinaBuy Comparées',
    article_3_desc: 'Comparez les options d\'expédition, les coûts, les délais de livraison et les fonctionnalités de suivi pour choisir la meilleure méthode.',
    article_4_title: 'AllChinaBuy est-il Sûr ? Guide Complet de Sécurité',
    article_4_desc: 'Découvrez les mesures de sécurité, la protection des paiements, la vérification des vendeurs et comment éviter les arnaques courantes.',
    article_5_title: 'Avis AllChinaBuy 2026',
    article_5_desc: 'Un examen détaillé de l\'expérience de commande, du service d\'entrepôt, du contrôle qualité et de l\'expédition AllChinaBuy.',
    article_6_title: 'Guide des Coûts d\'Expédition AllChinaBuy',
    article_6_desc: 'Comprenez les tarifs, méthodes, coûts cachés et stratégies pratiques pour réduire vos frais d\'expédition AllChinaBuy.',
    article_7_title: 'Guide de l\'Entrepôt AllChinaBuy',
    article_7_desc: 'Comment fonctionne l\'entrepôt AllChinaBuy, les périodes de stockage gratuites, les photos QC et la consolidation expliqués.',
    article_8_title: 'Guide des Coupons AllChinaBuy',
    article_8_desc: 'Découvrez comment fonctionnent les promotions AllChinaBuy, d\'où viennent les vraies réductions et comment éviter les faux coupons.',
    article_9_title: 'AllChinaBuy est-il Légitime ?',
    article_9_desc: 'Ce qui fait d\'AllChinaBuy une plateforme légitime, où se situent les vrais risques et comment vous protéger.',
    article_10_title: 'Guide des Vendeurs AllChinaBuy',
    article_10_desc: 'Comment évaluer les vendeurs, repérer les signaux d\'alarme et constituer une liste de vendeurs fiables.',
    article_11_title: 'Comment Trouver des Produits sur AllChinaBuy',
    article_11_desc: 'Stratégies de recherche efficaces, filtres et conseils de vérification pour trouver des produits de qualité plus rapidement.',
    article_12_title: 'Guide d\'Achat AllChinaBuy',
    article_12_desc: 'Un guide complet du processus d\'achat AllChinaBuy, de votre première commande à la livraison finale.',
    article_13_title: 'Guide du Calculateur d\'Expédition AllChinaBuy',
    article_13_desc: 'Comment estimer les coûts d\'expédition avec précision et utiliser les résultats pour prendre de meilleures décisions.',
    article_14_title: 'Erreurs Courantes AllChinaBuy',
    article_14_desc: 'Évitez les erreurs les plus fréquentes des nouveaux acheteurs et achetez en toute confiance dès le premier jour.',
  },
  features: {
    title: 'Pourquoi Utiliser Nos Ressources AllChinaBuy Spreadsheet ?',
    feature_1_title: 'Listes de Produits Organisées',
    feature_1_desc: 'Trouvez des produits dans toutes les catégories avec des spreadsheets structurés qui vous font gagner des heures de recherche.',
    feature_2_title: 'Informations Vendeurs',
    feature_2_desc: 'Accédez aux données détaillées des vendeurs, aux évaluations et aux gammes de produits pour des choix d\'achat confiants.',
    feature_3_title: 'Guides QC & Qualité',
    feature_3_desc: 'Comprenez les processus de contrôle qualité et apprenez ce qu\'il faut vérifier avant de confirmer les commandes.',
    feature_4_title: 'Ressources d\'Expédition',
    feature_4_desc: 'Comparez les méthodes d\'expédition, les coûts et les délais de livraison pour optimiser votre stratégie d\'achat.',
  },
  footer: {
    title: 'Hub AllChinaBuy Spreadsheet',
    description: 'Votre ressource indépendante pour les guides AllChinaBuy spreadsheet, listes de produits et informations d\'achat.',
    links: 'Liens Rapides',
    resources: 'Ressources',
    legal: 'Légal',
    privacy: 'Politique de Confidentialité',
    terms: 'Conditions d\'Utilisation',
    disclaimer: 'Avertissement',
    contact: 'Contact',
    copyright: '© 2026 Hub AllChinaBuy Spreadsheet. Tous droits réservés.',
    disclaimer_text: 'Ce site est une ressource d\'information indépendante. Les informations peuvent changer et doivent être vérifiées indépendamment avant de prendre des décisions d\'achat.',
  },
  not_found: {
    title: 'Page Non Trouvée',
    description: 'La page que vous recherchez n\'existe pas. Retournez à l\'accueil pour explorer les ressources AllChinaBuy spreadsheet.',
    back_home: 'Retour à l\'Accueil',
  },
  seo: {
    meta_title: 'AllChinaBuy Spreadsheet – Produits, Vendeurs, QC & Guides d\'Achat',
    meta_description: 'Explorez les derniers spreadsheet AllChinaBuy, ressources produits, guides vendeurs, conseils QC, informations d\'expédition et guides d\'achat. Trouvez des produits plus rapidement et achetez plus intelligemment.',
  },
  dropdown: {
    select_category: 'Sélectionner une Catégorie',
    go: 'Aller',
  },
  products: {
    title: 'Produits en vedette',
    subtitle: 'Explorez les produits sélectionnés de notre feuille de calcul AllChinaBuy — cliquez sur un article pour voir les détails et l\'acheter sur notre site principal.',
    view_all: 'Voir tout',
  },
  faq: {
    title: 'Questions Fréquemment Posées',
    q1: 'Qu\'est-ce que le AllChinaBuy Spreadsheet ?',
    a1: 'Le spreadsheet AllChinaBuy est une ressource organisée qui aide les acheteurs à trouver des produits, des vendeurs et des informations d\'achat dans plusieurs catégories. Il fait gagner du temps en collectant des liens utiles et des détails de produits en un seul endroit.',
    q2: 'AllChinaBuy est-il sûr à utiliser ?',
    a2: 'AllChinaBuy est une plateforme légitime. Cependant, comme pour tout marketplace en ligne, les acheteurs doivent vérifier les vendeurs, consulter les photos QC et utiliser des méthodes de paiement sécurisées. Nos guides vous aident à acheter en toute sécurité.',
    q3: 'Comment trouver les meilleurs produits ?',
    a3: 'Utilisez nos guides de catégorie et nos ressources spreadsheet pour comparer les produits entre les vendeurs. Lisez les guides QC et consultez les avis avant d\'effectuer des achats.',
    q4: 'Quelles méthodes d\'expédition sont disponibles ?',
    a4: 'AllChinaBuy propose diverses options d\'expédition. Consultez notre guide de comparaison pour trouver la meilleure méthode selon votre emplacement, votre budget et vos besoins de livraison.',
  },
};